(function () {
    const HEADER_SEL = ".flex.justify-between.px-7\\.5.pt-7\\.5";
    const DRAWER_SEL = ".cart-drawer";
    const ANCHOR_ID = "ig-progress-anchor";
    const CLONE_WRAP_ID = "ig-progress-clone";

    let scheduled = false;

    function $(sel, root) { return (root || document).querySelector(sel); }

    function ensureAnchor() {
        const header = $(HEADER_SEL);
        if (!header) return null;
        if (header.nextElementSibling && header.nextElementSibling.id === ANCHOR_ID) {
        return header.nextElementSibling;
        }
        const a = document.createElement("div");
        a.id = ANCHOR_ID;
        a.style.padding = "0 1.875rem";
        a.style.marginTop = ".5rem";
        header.insertAdjacentElement("afterend", a);
        return a;
    }

    function findSource() {
        const drawer = $(DRAWER_SEL);
        const all = Array.from(document.querySelectorAll("ig-shipping-progress-container"));
        if (!all.length) return null;
        if (!drawer) return all[0];
        return all.find(n => !drawer.contains(n)) || all[0];
    }

    function renderClone() {
        try {
        const anchor = ensureAnchor();
        if (!anchor) return;

        const src = findSource();
        if (!src) return;

        let wrap = anchor.querySelector(`#${CLONE_WRAP_ID}`);
        const html = src.outerHTML;

        if (!wrap) {
            wrap = document.createElement("div");
            wrap.id = CLONE_WRAP_ID;
            anchor.appendChild(wrap);
        }

        if (wrap.getAttribute("data-hash") !== String(html.length)) {
            wrap.innerHTML = html;
            wrap.setAttribute("data-hash", String(html.length));
            const cloned = wrap.querySelector("ig-shipping-progress-container");
            if (cloned) cloned.setAttribute("data-ig-clone", "cart");
        }
        } catch (e) {
        console.error("[ig-progress] renderClone error:", e);
        }
    }

    function scheduleRender() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
        renderClone();
        setTimeout(renderClone, 60);
        setTimeout(renderClone, 200);
        setTimeout(renderClone, 500);
        scheduled = false;
        });
    }

    function boot() {
        scheduleRender();

        const drawer = $(DRAWER_SEL);
        if (drawer) {
        const mo = new MutationObserver((mutations) => {
            const anchor = document.getElementById(ANCHOR_ID);
            const cloneWrap = anchor && anchor.querySelector(`#${CLONE_WRAP_ID}`);
            const causedByClone = mutations.every(m => cloneWrap && (cloneWrap === m.target || cloneWrap.contains(m.target)));
            if (causedByClone) return;
            scheduleRender();
        });
        mo.observe(drawer, { childList: true, subtree: true });
        }

        document.addEventListener("cart:updated", scheduleRender);
        document.addEventListener("alpine:init", scheduleRender);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }
})();
